import { useFeature } from 'hooks'
import { DefaultProps } from 'typings'
import { Loading } from '../components/Form/Loading'

export function FeatureWrapper(props: DefaultProps) {
  const { isLoading } = useFeature()

  if (isLoading) {
    return <Loading />
  }

  return <>{props.children}</>
}
